import useFollowStatus from '../../data-service/useFollowStatus'

type Props = {
  pid?: string
}

/**
 * Fetches the follow status alongside the person, so the banner's Follow placeholder can swap straight to Follow
 * instead of waiting on a second request after the banner mounts. It's its own component so the request's SWR state
 * changes re-render only this, not the whole page.
 *
 * Its toggle listeners also keep the cached status current while the banner's Follow is unmounted (xs widths, where
 * Follow lives in the mobile menu), so the banner shows the right state when it reappears.
 */
export default function FollowStatusPrefetch({ pid }: Props): null {
  useFollowStatus(pid)
  return null
}
